<template>
  <CustomCreateDialog
    dialogTitle="ایجاد گروه‌بندی درس جدید"
    dialogId="create-lesson-category-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="createLessonCategory"
  >
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="lessonCategoryPayloadTitle"
        inputLabel="عنوان گروه‌بندی درس"
        inputPlaceholder="مقدماتی..."
        v-model="newLessonCategoryPayload.title"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <TextInput
        customRules="required|between:0,100"
        type="number"
        inputId="lessonCategoryPayloadPercent"
        inputLabel="درصد تخفیف گروه‌بندی"
        inputPlaceholder="10"
        v-model="newLessonCategoryPayload.discountPercent"
      >
        <template #append> % </template>
      </TextInput>
    </BCol>
    <BCol cols="12">
      <IndependentLessonPicker
        is-multiple
        is-in-dialog
        @getLesson="setLessons"
      ></IndependentLessonPicker>
    </BCol>
    <BCol cols="12">
      <SupportPackagePicker
        :defaultCounselingPackageId="
          newLessonCategoryPayload.counselingPackageId
        "
        @getSupportPackage="setSupportPackage"
      ></SupportPackagePicker>
    </BCol>
    <BCol cols="12">
      <BFormCheckbox
        v-model="newLessonCategoryPayload.requirementForSupport"
        name="check-button"
        switch
      >
        <small style="margin-left: 3px"> آیا پیشنیاز پشتیبانی است؟ </small>

        <b
          >({{
            newLessonCategoryPayload.requirementForSupport ? "بله" : "خیر"
          }})</b
        >
      </BFormCheckbox>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      newLessonCategoryPayload: {
        id: null,
        title: null,
        discountPercent: null,
        lessonIds: [],
        counselingPackageId: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async createLessonCategory() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let createNewLessonCategory = new CreateNewLessonCategory(_this);
        createNewLessonCategory.setRequestParamDataObj(
          _this.newLessonCategoryPayload
        );
        await createNewLessonCategory.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "گروه‌بندی درس با موفقیت ایجاد شد.",
              },
            });
            _this.newLessonCategoryPayload = {
              id: null,
              title: null,
              discountPercent: null,
              lessonIds: [],
            };
            this.$bvModal.hide("create-lesson-category-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
    setLessons(lessonIds) {
      this.newLessonCategoryPayload.lessonIds = lessonIds;
    },
    setSupportPackage(counselingPackageId) {
      this.newLessonCategoryPayload.counselingPackageId = counselingPackageId;
    },
  },
  components: {
    CustomCreateDialog,
    IndependentLessonPicker,
    BCol,
    BFormCheckbox,
    TextInput,
    SupportPackagePicker,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol, BFormCheckbox } from "bootstrap-vue";
import { CreateNewLessonCategory } from "@/libs/Api/LessonCategory";
import SupportPackagePicker from "@/views/components/LessonCategories/SupportPackagePicker.vue";
</script>
